import gql from 'graphql-tag';
export const playsForFragment = gql `
  fragment PlaysFor on TeamWithPlayerPhoto {
    team {
      id
      name
      abbreviation
      sport {
        id
        name
      }
      abbreviation
      logo {
        id
        url
      }
      competitions {
        id
        name
        logo {
          id
          url
        }
      }
    }
    position
    positionType
    number
    defaultStarter
    photo {
      id
      url
    }
  }
`;
//# sourceMappingURL=PlaysFor.js.map